export default __webpack_public_path__ + "static/media/Reader's Belt of the Effulgent Blade.0b77eea8.jpg";